import(/* webpackMode: "eager", webpackExports: ["FeedbackAlert"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/feedback-alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CreatePageIcon","PollPageIcon","EventPageIcon","SettingsPageIcon","MembersPageIcon","BillingPageIcon"] */ "/app/apps/web/src/app/components/page-icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer","PageHeader","PageTitle","PageContent"] */ "/app/apps/web/src/app/components/page-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Trans"] */ "/app/apps/web/src/components/trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IfFeatureEnabled"] */ "/app/apps/web/src/lib/feature-flags/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.6_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-_0314d785ff5c15f857d19489caa2dd52/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TileGrid","Tile","TileTitle","TileDescription"] */ "/app/packages/ui/src/tile.tsx");
